import { Card, Col, Typography } from "antd";
import React, { useEffect, useState } from "react";

const { Title, Text } = Typography;

const PowerDemand = ({ dataCards, mainDashboardData }) => {
  //console.log(dataCards);
  // console.log(mainDashboardData);
  const [blinkingIndexes, setBlinkingIndexes] = useState([]);
  const data = [
    {
      title: "Daily Peak Demand",
      value: "132",
      unit: "kVA",
      target: "200",
      liveValue: "250",
      lowThreshold: "100",
      highThreshold: "150",
    },
    {
      title: "MTD Peak Demand",
      value: "18",
      unit: "kVA",
      target: "200",
      liveValue: "120",
      lowThreshold: "100",
      highThreshold: "150",
    },
    {
      title: "Live Demand",
      value: "12",
      unit: "kVA",
      target: "200",
      liveValue: "250",
      lowThreshold: "100",
      highThreshold: "150",
    },
    {
      title: "Real Power",
      value: "32",
      unit: "kW",
      target: "200",
      liveValue: "250",
      lowThreshold: "100",
      highThreshold: "150",
    },
    {
      title: "Reactive Power",
      value: "142",
      unit: "kVAr",
      target: "200",
      liveValue: "250",
      lowThreshold: "100",
      highThreshold: "150",
    },
    {
      title: "Power Factor",
      value: "62",
      unit: "",
      target: "200",
      liveValue: "250",
      lowThreshold: "100",
      highThreshold: "150",
    },
    {
      title: "Voltage",
      value: "72",
      unit: "V",
      target: "200",
      liveValue: "250",
      lowThreshold: "100",
      highThreshold: "150",
    },
    {
      title: "Current",
      value: "152",
      unit: "A",
      target: "200",
      liveValue: "250",
      lowThreshold: "100",
      highThreshold: "150",
    },
    {
      title: "V THD",
      value: "92",
      unit: "%",
      target: "200",
      liveValue: "250",
      lowThreshold: "100",
      highThreshold: "150",
    },
    {
      title: "I THD",
      value: "22",
      unit: "%",
      target: "200",
      liveValue: "140",
      lowThreshold: "100",
      highThreshold: "150",
    },
  ];

  useEffect(() => {
    const blinking = mainDashboardData.reduce((indexes, item, i) => {
      const live = parseFloat(item.parameterLiveValue);
      const low = parseFloat(item.lowThreshold);
      const high = parseFloat(item.highThreshold);
      if (live < low || live > high) indexes.push(i);
      return indexes;
    }, []);
    setBlinkingIndexes(blinking);
  }, [mainDashboardData]);
  // console.log(mainDashboardData);
  const getStatusColor = (type, name, live, target) => {
    // console.log(name);
    if (name == "VLLAvg") {
      return {
        arrow: live < target ? "↓ ": "↑ ",
        status: live < target ? "danger" : "success",
      };
    }
    return {
      arrow: live < target ?"↓ ": "↑ "  ,
      status:live < target ? "success" : "danger"
    }
    if (
      title === "Kvat Day" ||
      title === "Kvat MTD" ||
      title === "KVAT Live" ||
      title === "KWT Live" ||
      title === "KVART Live" ||
      title === "V_THDAvg Live" ||
      title === "I_THDAvg Live"
    ) {
    }
    if (title === "VLLAvg Live" || title === "IAVG Live") {
      if (live == 0) {
        return "danger";
      }
      return live < target ? "danger" : "success";
    }
    if (title === "PFT Live") {
      if (live == 0) {
        return "danger";
      }
      if (live < 0 || live < target) {
        return "danger"; // red
      } else {
        return "success"; // green
      }
    }
    return undefined;
  };
  const getTitleAndUnit = (title) => {
    if (title === "Kvat Day") {
      return {
        title: "Daily Peak Demand",
        unit: "kvat",
      };
    }
    if (title === "Kvat MTD") {
      return {
        title: "MTD Peak Demand",
        unit: "kvat",
      };
    }
    if (title === "KVAT Live") {
      return {
        title: "Live Demand",
        unit: "kvat",
      };
    }
    if (title === "KWT Live") {
      return {
        title: "Real Power",
        unit: "kwt",
      };
    }
    if (title === "KVART Live") {
      return {
        title: "Reactive Power",
        unit: "kvart",
      };
    }
    if (title === "V_THDAvg Live") {
      return {
        title: "V THD",
        unit: "%",
      };
    }
    if (title === "I_THDAvg Live") {
      return {
        title: "I THD",
        unit: "%",
      };
    }
    // if (title === "VLLAvg Live" || title === "IAVG Live") {
    //   return live < target ? "danger" : "success";
    // }
    if (title === "VLLAvg Live") {
      return {
        title: "Voltage",
        unit: "V",
      };
    }
    if (title === "IAVG Live") {
      return {
        title: "Current",
        unit: "A",
      };
    }
    if (title === "PFT Live") {
      return {
        title: "Power Factor",
        unit: "pf",
      };
    }
    return undefined;
  };
  // console.log(mainDashboardData);
  //console.log(getTitleAndUnit("Kvat Day").title)
  return (
    <>
      {mainDashboardData.map((card, index) => {
        const isBlinking = blinkingIndexes.includes(index);
        return (
          <Col key={index} xs={24} sm={12} md={8} lg={6} xl={4}>
            <Card
              size="small"
              hoverable
              className={isBlinking ? "blink-card" : ""}
            >
              <Title level={5}>{card.parameterTitle || "Title"}</Title>
              <Text strong style={{ fontSize: 20 }}>
                {card.parameterLiveValue}
                <span style={{ fontSize: 14, paddingLeft: "10px" }}>
                  {getTitleAndUnit(card.parameterStatus)?.unit || ""}
                </span>
              </Text>
              <br />
              <Text
                type={getStatusColor(
                  card.parameterType,
                  card.parametereName,
                  card.parameterLiveValue,
                  card.parameterTargetValue
                ).status}
              >
                {getStatusColor(
                  card.parameterType,
                  card.parametereName,
                  card.parameterLiveValue,
                  card.parameterTargetValue
                ).arrow}
                  {" "}
                {card.parameterValue}%{" "}
                <span style={{ color: "gray" }}>
                  vs {card.parameterTargetValue}
                </span>
              </Text>
            </Card>
          </Col>
        );
      })}
    </>
  );
};

export default PowerDemand;
